import { rMoveAppConfig } from 'src/configs/app/app.config';
import { ShortDistanceProdConfig } from 'src/configs/distance/short-distance.config';
import { ProdMapConfig } from 'src/configs/maps.config';
import { Environment, logEnvironmentInfo } from './environment.utils';

export const environment: Environment = {
  production: true,
  name: 'production',
  serverUrl: 'https://central.rmove.rsginc.com',
  browserAppConfig: rMoveAppConfig,
  distanceConfig: ShortDistanceProdConfig,
  mapConfig: ProdMapConfig,
};

logEnvironmentInfo(environment);
